module.exports = __webpack_public_path__ + "merriweather-regular-webfont.4fdb06030633cdd9c005.svg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/merriweather-regular-webfont.svg
// module id = ../../../../../src/assets/fonts/merriweather-regular-webfont.svg
// module chunks = 2